import AlertDialog from '@/components/Dialog/AlertDialog';
import DialogComponent from '@/components/Dialog/Dialog';
import LoadingDialog from '@/components/Dialog/LoadingDialog';
import Shop3LoginDialog from '@/components/Dialog/Shop3LoginDialog';
import VendorLoginDialog from '@/components/Dialog/VendorLoginDialog';
import { isLogined } from '@/services/mallUser.service';
import { useLazyMallAppBarHeight } from '@/store/lazyMallStore';
import { useOrderNPayStore } from '@/store/orderNPayStore';
import { useOrderNumberStore } from '@/store/orderNumberStore';
import { useUserStore } from '@/store/userStore';
import { useVendorLoginDialogStore } from '@/store/vendorLoginDialogStore';
import analytics from '@/utils/analytics';
import { Box, CssBaseline, Fade, useScrollTrigger } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useLocation, useRevalidator } from 'react-router-dom';
import { useEffect, useState } from 'react';
import theme from '../Theme/defaultTheme';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ChatProfile from '@/components/Chat/ChatProfile';
import ChatDialog from '@/components/Chat/ChatDialog';

export default function HomeContainer({ children }) {
    const location = useLocation();
    analytics();
    const mallUserId = useUserStore((state) => state.mallUserId);
    const { isOpen: isVendorLoginOpen, setIsOpen: setVendorLoginOpen } = useVendorLoginDialogStore();
    const revalidator = useRevalidator();
    const appBarHeight = useLazyMallAppBarHeight();
    const [chatOpen, setChatOpen] = useState(false);

    // 채팅 버튼을 숨길 페이지들 확인
    const hideChatPages = ['/', '/subscription', '/account/settings'];
    const shouldHideChat = hideChatPages.includes(location.pathname);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!isLogined()) {
            const currentPathRouter = location.pathname.split('/')[3];
            const orderPage = ['tracking-info', 'order-detail-info', 'order-n-shipping-info', 'refund', 'cancel'];
            const isOrderPage = orderPage.filter((item) => item.includes(currentPathRouter));
            if (isOrderPage.length !== 0) {
                useOrderNumberStore.setState({
                    isOrderPage: true,
                });
            } else {
                useOrderNumberStore.setState({
                    isOrderPage: false,
                });
            }
        }
    }, [location.pathname]);
    useEffect(() => {
        revalidator.revalidate();
    }, [mallUserId]);
    useEffect(() => {
        const payData = { ...useOrderNPayStore.getState() };
        const deleteTarget = Object.keys(payData)
            .filter((item) => !isNaN(Number(item)))
            .filter((item) => new Date().getTime() - Number(item) > 432000000); // 5일 후 삭제 432,000,000
        const check = deleteTarget.length === 1 && deleteTarget[0] === '';
        if (check) return;
        deleteTarget.forEach((item) => {
            delete payData[item];
        });
        useOrderNPayStore.getState().update(payData);
    }, []);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div id="back-to-top-anchor-home" />
            <Box
                display="flex"
                flexDirection="column"
                width={'100%'}
                sx={{
                    pb: { xs: '60px', sm: 0 }, // 모바일에서 하단 네비게이션 바 높이만큼 여백 추가
                }}
            >
                {children}

                <ScrollToTopButton />
                <Shop3LoginDialog />
                <VendorLoginDialog isOpen={isVendorLoginOpen} onClose={() => setVendorLoginOpen(false)} />
                <LoadingDialog />
                <AlertDialog />
                <DialogComponent />
                {!shouldHideChat && (
                    <>
                        <Box
                            sx={{
                                position: 'fixed',
                                right: theme.spacing(7),
                                bottom: theme.spacing(12),
                                display: 'flex',
                                zIndex: 1200,
                                [theme.breakpoints.down('sm')]: {
                                    right: theme.spacing(6),
                                    bottom: theme.spacing(10),
                                },
                            }}
                            onClick={() => {
                                setChatOpen((prev) => !prev);
                            }}
                        >
                            <ChatProfile />
                        </Box>
                        <ChatDialog open={chatOpen} setOpen={setChatOpen} />
                    </>
                )}
            </Box>
        </ThemeProvider>
    );
}

function ScrollToTopButton({}) {
    const trigger = useScrollTrigger({
        target: window ? window : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    return (
        <Fade in={trigger}>
            <Box
                onClick={(e) => {
                    const anchor = ((e.target as HTMLDivElement).ownerDocument || document).querySelector(
                        '#back-to-top-anchor-home',
                    );
                    if (anchor) {
                        anchor.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                        });
                    }
                }}
                sx={{
                    position: 'fixed',
                    bottom: { xs: 25, md: 24 },
                    right: { xs: 16, md: 24 },
                    background: 'rgba(255,255,255,0.95)',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                    borderRadius: 1,
                    width: { xs: 40, md: 48 },
                    height: { xs: 40, md: 48 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': {
                        background: 'rgba(255,255,255,1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
                    },
                    zIndex: 1300,
                }}
            >
                <ArrowUpwardIcon
                    sx={{
                        fontSize: { xs: 24, md: 28 },
                        color: '#222',
                    }}
                />
            </Box>
        </Fade>
    );
}
